import React from 'react';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import '../styles/connect-wallet.css';

const ConnectWallet = () => {
  return (
    <ConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        authenticationStatus,
        mounted,
      }) => {
        const ready = mounted && authenticationStatus !== 'loading';
        const connected =
          ready &&
          account &&
          chain &&
          (!authenticationStatus ||
            authenticationStatus === 'authenticated');

        return (
          <div
            {...(!ready && {
              'aria-hidden': true,
              'style': {
                opacity: 0,
                pointerEvents: 'none',
                userSelect: 'none',
              },
            })}
          >
            {(() => {
              if (!connected) {
                return (
                  <button
                    onClick={openConnectModal}
                    type="button"
                    className="connect-wallet-btn"
                  >
                    Connect Wallet
                  </button>
                );
              }

              if (chain.unsupported) {
                return (
                  <button
                    onClick={openChainModal}
                    type="button"
                    className="connect-wallet-btn"
                    style={{ background: '#ef4444' }}
                  >
                    Wrong network
                  </button>
                );
              }

              return (
                <div className="wallet-buttons-group">
                  <button
                    onClick={openChainModal}
                    type="button"
                    className="connect-wallet-btn chain-button"
                  >
                    {chain.hasIcon && (
                      <div className="chain-icon-wrapper">
                        <img
                          alt={chain.name ?? 'Chain icon'}
                          src={chain.iconUrl}
                          className="chain-icon"
                        />
                      </div>
                    )}
                    <span className="chain-name">{chain.name}</span>
                  </button>

                  <button
                    onClick={openAccountModal}
                    type="button"
                    className="connect-wallet-btn connected"
                  >
                    <span className="wallet-address">
                      <span>{account.displayName}</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="1em"
                        height="1em"
                        fill="currentColor"
                        viewBox="0 0 256 256"
                      >
                        <rect width="256" height="256" fill="none"></rect>
                        <line
                          x1="200"
                          y1="56"
                          x2="56"
                          y2="200"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="16"
                        ></line>
                        <line
                          x1="200"
                          y1="200"
                          x2="56"
                          y2="56"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="16"
                        ></line>
                      </svg>
                    </span>
                  </button>
                </div>
              );
            })()}
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
};

export default ConnectWallet;

